import * as React from 'react';

import { cn } from '../../lib/utils';

const Card = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'rounded-[2rem] border border-white/70 bg-card text-card-foreground shadow-card',
        className
      )}
      {...props}
    />
  )
);
Card.displayName = 'Card';

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-8 sm:p-10', className)} {...props} />
));
CardContent.displayName = 'CardContent';

export { Card, CardContent };
